import "./About.css";

const About = () => {
  return (
    <section className="about" id = "about">
      <div className="about-container">

        {/* LEFT SIDE */}
        <div className="about-left">
          <div className="service-grid">
            <div className="service-box">Web Apps</div>
            <div className="service-box">Mobile Apps</div>
            <div className="service-box">Enterprise Software</div>
            <div className="service-box">Game Development</div>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="about-right">
          <span className="about-tag">ABOUT US</span>
          <h2>
            Your Full-Service <span>Technology Partner</span>
          </h2>

          <p>
            Shirdhankar Technologies is a full-service technology partner focused
            on building scalable, secure, and high-performance digital solutions.
            We combine creativity, engineering excellence, and business understanding
            to deliver impactful products.
          </p>

          <p>
            From concept to launch, we turn ideas into market-ready digital
            products that drive real business outcomes.
          </p>
        </div>

      </div>

      {/* ACHIEVEMENTS 
      <div className="achievements">
        <div className="achievement-card">
          <div className="number">150+</div>
          <span>Projects Delivered</span>
        </div>

        <div className="achievement-card">
          <div className="number">80+</div>
          <span>Happy Clients</span>
        </div>

        <div className="achievement-card">
          <div className="number">50+</div>
          <span>Apps & Platforms Built</span>
        </div>

        <div className="achievement-card">
          <div className="number">8+</div>
          <span>Years of Experience</span>
        </div>
      </div>*/}
    </section>
  );
};

export default About;
